import type { PlayerIndex, TicTacToeState } from "@playpal/core";
import { playerStyle } from "../components/ui";

interface Props {
	state: TicTacToeState;
	seat: PlayerIndex;
	onMove: (move: unknown) => void;
}

const MARK = ["✕", "◯"] as const;

export function TicTacToeBoard({ state, seat, onMove }: Props) {
	const myTurn = state.turn === seat && !state.result;

	return (
		<div className="board-frame board-md grid aspect-square grid-cols-3 gap-3">
			{state.board.map((cell, index) => {
				const winning = state.winningLine?.includes(index) ?? false;
				const label = cell === null ? `Square ${index + 1}, empty` : `Square ${index + 1}`;
				return (
					<button
						// The board is fixed at nine squares, so the index is a stable key.
						key={index}
						type="button"
						disabled={!myTurn || cell !== null}
						aria-label={label}
						onClick={() => onMove({ square: index })}
						className={`flex items-center justify-center rounded-3xl text-6xl font-black shadow-inner transition sm:text-7xl ${
							winning ? "bg-amber-300/90 text-amber-900" : "bg-white/70 dark:bg-white/10"
						} ${cell === null && myTurn ? "hover:scale-[1.03] hover:bg-white" : ""} ${
							cell !== null ? (cell === 0 ? "text-rose-500" : "text-sky-500") : ""
						}`}
					>
						<span className={cell !== null ? "animate-pop" : ""}>
							{cell === null ? "" : MARK[cell]}
						</span>
					</button>
				);
			})}
		</div>
	);
}

export function ticTacToeHint(state: TicTacToeState, seat: PlayerIndex): string {
	if (state.result) return "";
	return state.turn === seat
		? `Your turn — you are ${MARK[seat]} (${playerStyle(seat).name})`
		: "Waiting for your friend…";
}
